import { makeHttpRequest } from "@/shared";

export const deleteDiscounts = async (ids) => {
    return (
        await makeHttpRequest({
            url: "/discount/delete-multiple",
            method: "DELETE",
            params: { items: ids },
        })
    ).data;
};
